<template>
  <v-tabs fixed-tabs fill-height v-model="active">
    <v-tab :label="`CURRENT`">CURRENT</v-tab>
    <v-tab-item>
      <v-container grid-list-md text-xs-center class="button-container">
        <v-layout row wrap align-center justify-space-around>
          <v-flex xs3 class="button-cards">
            <v-card class="value-button-design">
              <v-card-text class="primary title-name white--text">SPONSOR</v-card-text>
              <v-img v-bind:src="createURL(clip.sponsorIcon.handle)" class="tabs-sponsor-image"></v-img>
              <v-spacer></v-spacer>
              <div class="primary button-name white--text">{{clip.active.sponsor}}</div>
            </v-card>
          </v-flex>
          <v-flex xs3 class="button-cards">
            <v-card class="value-button-design">
              <v-card-text class="primary title-name white--text">TYPE</v-card-text>
              <v-icon large center class="value-icon">{{clip.typeIcon}}</v-icon>
              <v-spacer></v-spacer>
              <div class="primary button-name white--text">{{clip.active.type}}</div>
            </v-card>
          </v-flex>
          <v-flex xs3 class="button-cards">
            <v-card class="value-button-design">
              <v-card-text class="primary title-name white--text">LOCATION</v-card-text>
              <v-icon large center class="value-icon">{{clip.locationIcon}}</v-icon>
              <v-spacer></v-spacer>
              <div class="primary button-name white--text">{{clip.active.location}}</div>
            </v-card>
          </v-flex>
          <v-flex xs3 class="button-cards">
            <v-card class="value-button-design">
              <v-card-text class="primary title-name white--text">CLARITY</v-card-text>
              <v-icon large center class="value-icon">{{clip.clarityIcon}}</v-icon>
              <v-spacer></v-spacer>
              <div class="primary button-name white--text">{{clip.active.clarity}}</div>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>

      <v-card grid-list-md text-xs-center class="timer-container">
        <v-layout row wrap>
          <v-flex xs4>
            <div class="timer" @click="pressTimer(clip.active.clipStart)">
              <v-icon medium>icons8-stopwatch</v-icon>
              <span
                class="timer-values"
              >&nbsp;&nbsp; {{this.changeTimeFormat(clip.active.clipStart)}}</span>
            </div>
          </v-flex>
          <v-flex xs4>
            <div class="timer" @click="pressTimer(clip.active.clipEnd)">
              <v-icon medium>icons8-finish-flag</v-icon>
              <span class="timer-values">&nbsp;&nbsp; {{this.changeTimeFormat(clip.active.clipEnd)}}</span>
            </div>
          </v-flex>
          <v-flex xs4>
            <div class="timer">
              <v-icon medium>icons8-future</v-icon>
              <span
                class="timer-values"
              >&nbsp;&nbsp; {{this.changeTimeFormat(clip.active.clipDuration)}}</span>
            </div>
          </v-flex>
        </v-layout>
      </v-card>

      <v-container grid-list-md text-xs-center class="button-container" v-if="!isMobile()">
        <v-layout row wrap>
          <v-flex xs12>
            <vue-good-table
              :columns="Columns"
              :rows="rows"
              max-height="350px"
              responsive
              styleClass="vgt-table responsive condensed"
              row-style-class="tablerowheight"
              :pagination-options="{
                enabled: true,
                mode: 'records',
                perPage: 5,
                position: 'bottom',
                setCurrentPage: 1,
                nextLabel: 'next',
                prevLabel: 'prev',
                ofLabel: 'of',
                pageLabel: 'page', // for 'pages' mode
                allLabel: 'All',
              }"
            >
              <template slot="table-column" slot-scope="props">
                <span class="tablerowheight">{{props.column.label}}</span>
              </template>
              <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field == 'clipStart'">
                  <span>{{changeTimeFormat(props.row.clipStart)}}</span>
                </span>
                <span v-if="props.column.field == 'clipDuration'">
                  <span style="text-align: center">{{changeTimeFormat(props.row.clipDuration)}}</span>
                </span>
                <span v-if="props.column.field == 'sponsor'">
                  <span style="text-align: center">{{props.row.sponsor}}</span>
                </span>
                <span v-if="props.column.field == 'type'">
                  <span style="text-align: center">{{props.row.type}}</span>
                </span>
                <span v-if="props.column.field == 'location'">
                  <span style="text-align: center">{{props.row.location}}</span>
                </span>
                <span v-if="props.column.field == 'clarity'">
                  <span style="text-align: center">{{props.row.clarity}}</span>
                </span>
                <span v-if="props.column.field == 'status'">
                  <span style="text-align: center">{{props.row.status}}</span>
                </span>
                <span v-if="props.column.field == 'action'">
                  <v-icon
                    style="width:20px; height:20px; margin-right:10px"
                    color="primary"
                    @click="pressButton(props.row.clipStart, props.row.clipDuration, props.row.name)"
                  >icons8-play</v-icon>
                  <v-icon
                    style="width:20px; height:20px; margin-right:10px"
                    color="primary"
                    @click="delVideo(props.row.id, props.row.name)"
                  >icons8-paper-bin</v-icon>
                  <v-icon
                    style="width:20px; height:20px;"
                    color="primary"
                    v-if="expandSelected === true"
                    @click="deselect(props.index)"
                  >icons8-arrow</v-icon>
                  <v-icon
                    style="width:20px; height:20px;"
                    color="primary"
                    v-else-if="expandSelected === false"
                    @click="selectRow(props.index)"
                  >icons8-drop-down-arrow</v-icon>
                </span>
                <span
                  v-if="expandSelected === true && props.index === rowIndex && props.column.field == 'clipStart'"
                >
                  <div class="details-div">
                    <span class="details-title">Type:</span>
                    {{props.row.type}}
                  </div>
                  <div class="details-div">
                    <span class="details-title">Location:</span>
                    {{props.row.location}}
                  </div>
                  <div class="details-div">
                    <span class="details-title">Clarity:</span>
                    {{props.row.clarity}}
                  </div>
                  <div class="details-div">
                    <span class="details-title">Status:</span>
                    {{props.row.status}}
                  </div>
                </span>
              </template>
            </vue-good-table>
          </v-flex>
        </v-layout>
      </v-container>
    </v-tab-item>

    <!-- CLIPS -->
    <v-tab :label="`CLIPS`">
      CLIPS
      <span v-if="clipCount !== 0">({{ clipCount }})</span>
    </v-tab>
    <v-tab-item>
      <!-- radio btns + select -->
      <v-layout row wrap align-center style="padding: 10px 5px 0px 5px !important">
        <v-flex xs6>
          <v-select
            v-model="selected"
            :items="rows"
            item-text="type"
            item-value="type"
            solo
            label="Type"
          ></v-select>
        </v-flex>

        <v-flex xs6>
          <v-select
            v-model="selected"
            :items="rows"
            item-text="sponsor"
            item-value="sponsor"
            solo
            label="Sponsor"
          ></v-select>
        </v-flex>
      </v-layout>
      <!-- table -->
      <v-layout row wrap>
        <div class="clips-table-container">
          <vue-good-table
            :columns="Columns"
            :rows="rows"
            max-height="350px"
            responsive
            styleClass="vgt-table responsive condensed"
            row-style-class="tablerowheight"
            :search-options="{
                enabled: true,
                externalQuery:  selected
            }"
            :pagination-options="{
                enabled: true,
                mode: 'records',
                perPage: 5,
                position: 'bottom',
                setCurrentPage: 1,
                nextLabel: 'next',
                prevLabel: 'prev',
                ofLabel: 'of',
                pageLabel: 'page', // for 'pages' mode
                allLabel: 'All',
              }"
          >
            <div class="publish-btn-div" slot="table-actions">
              <v-btn
                style="font-size:12px !important"
                color="primary"
                round
                @click="publishClips"
              >Publish Clips</v-btn>
            </div>
            <template slot="table-column" slot-scope="props">
              <span class="tablerowheight">{{props.column.label}}</span>
            </template>
            <template slot="table-row" slot-scope="props">
              <span v-if="props.column.field == 'clipStart'">
                <span>{{changeTimeFormat(props.row.clipStart)}}</span>
              </span>
              <span v-if="props.column.field == 'clipDuration'">
                <span style="text-align: center">{{changeTimeFormat(props.row.clipDuration)}}</span>
              </span>
              <span v-if="props.column.field == 'sponsor'">
                <span style="text-align: center">{{props.row.sponsor}}</span>
              </span>
              <span v-if="props.column.field == 'type'">
                <span style="text-align: center">{{props.row.type}}</span>
              </span>
              <span v-if="props.column.field == 'location'">
                <span style="text-align: center">{{props.row.location}}</span>
              </span>
              <span v-if="props.column.field == 'clarity'">
                <span style="text-align: center">{{props.row.clarity}}</span>
              </span>
              <span v-if="props.column.field == 'status'">
                <span style="text-align: center">{{props.row.status}}</span>
              </span>
              <span v-if="props.column.field == 'action'">
                <v-icon
                  style="width:20px; height:20px; margin-right:10px"
                  color="primary"
                  @click="pressButton(props.row.clipStart, props.row.clipDuration, props.row.name)"
                >icons8-play</v-icon>
                <v-icon
                  style="width:20px; height:20px; margin-right:10px"
                  color="primary"
                  @click="delVideo(props.row.id, props.row.name)"
                >icons8-paper-bin</v-icon>
                <v-icon
                  style="width:20px; height:20px;"
                  color="primary"
                  v-if="expandSelected === true"
                  @click="deselect(props.index)"
                >icons8-arrow</v-icon>
                <v-icon
                  style="width:20px; height:20px;"
                  color="primary"
                  v-else-if="expandSelected === false"
                  @click="selectRow(props.index)"
                >icons8-drop-down-arrow</v-icon>
              </span>
              <span
                v-if="expandSelected === true && props.index === rowIndex && props.column.field == 'clipStart'"
              >
                <div class="details-div">
                  <span class="details-title">Type:</span>
                  {{props.row.type}}
                </div>
                <div class="details-div">
                  <span class="details-title">Location:</span>
                  {{props.row.location}}
                </div>
                <div class="details-div">
                  <span class="details-title">Clarity:</span>
                  {{props.row.clarity}}
                </div>
                <div class="details-div">
                  <span class="details-title">Status:</span>
                  {{props.row.status}}
                </div>
              </span>
            </template>
          </vue-good-table>
        </div>
      </v-layout>
    </v-tab-item>

    <!--Fixture-->
    <v-tab :label="`FIXTURE`">FIXTURE</v-tab>
    <v-tab-item>
      <v-layout column>
        <div class="more-info-tabs pl-1 pr-3 mt-6">
          <table width="100%" border="0">
            <tr>
              <td class="more-info-title primary--text">Competition:</td>
              <td>{{game.competition}}</td>
            </tr>
            <tr>
              <td class="more-info-title primary--text">Fixture:</td>
              <td>{{game.gameName}}</td>
            </tr>
            <tr>
              <td class="more-info-title primary--text">Result:</td>
              <td>{{game.result}}</td>
            </tr>
            <tr>
              <td class="more-info-title primary--text">Venue:</td>
              <td>{{game.venue}}</td>
            </tr>
            <tr>
              <td class="more-info-title primary--text">Attendence:</td>
              <td>{{game.attendence}}</td>
            </tr>
            <tr>
              <td class="more-info-title primary--text">Broadcast Channel:</td>
              <td>{{game.tvChannel}}</td>
            </tr>
          </table>
          <br />
        </div>
      </v-layout>
    </v-tab-item>
  </v-tabs>
</template>

<script>
import { mapState } from "vuex";
import "@/components/video";
import "@/components/forms";
import adminSchema from "@/schemas/admin.json";
import Vue from "vue";
import { filestack } from "@/components/mixins/filestack.js";
export default {
  mixins: [filestack],
  props: {
    admin: {
      type: Object,
      default() {
        return {};
      }
    },
    schema: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      active: null,
      comment: "",
      selected: "",
      rows: [],
      game: [],
      expandSelected: false,
      rowIndex: null
    };
  },
  computed: {
    ...mapState({
      portal: state => state.portal,
      clip: state => state.clip,
      Clips: state => state.clip.Clips,
      actionsBtns: state => state.actionsBtns,
      gameID: state => state.game.gameID,
      GameByID: state => state.Admin.GameByID,
      sponByGameResult: state => state.clip.sponByGameResult
    }),
    Columns() {
      return adminSchema.clips.columns;
    },
    clipCount() {
      return this.rows.length;
    }
  },
  watch: {
    /*
    clips: {
      handler: function() {
        // console.log(JSON.stringify(this.clips, null, 2));
      },
      immediate: true,
      deep: true
    },
*/ sponByGameResult: {
      handler: function() {
        this.rows = this.$sortBy(this.sponByGameResult, "clipStart").reverse();
      },
      immediate: true,
      deep: true
    },
    admin: {
      handler: function() {
        this.readClipsByGame();
      },
      deep: true
    },
    Columns: {
      handler: function() {
        this.tableCol = this.Columns;
      }
    },
    GameByID: {
      handler: function() {
        this.game = this.GameByID;
      },
      deep: true
    },
    GameResultByID: {
      handler: function() {
        this.readGames();
      },
      deep: true
    }
  },
  methods: {
    next() {
      const active = parseInt(this.active);
      this.active = active < 2 ? active + 1 : 0;
    },
    changeTimeFormat(time) {
      var s = Math.floor(time % 60);
      var m = Math.floor((time / 60) % 60);
      var h = Math.floor(time / 3600);
      if (isNaN(time) || time === Infinity) {
        h = m = s = "--";
      }
      h = h > 0 ? h + ":" : "";
      m = (h && m < 10 ? "0" + m : m) + ":";
      s = s < 10 ? "0" + s : s;
      return (time = h + m + s);
    },
    readClipsByGame() {
      //console.log("GAME ID INITIAL: " + this.gameID);
      this.$store.dispatch("clip/getClipsByGame", [
        "clips",
        this.portal.active.id,
        this.gameID,
        "clip/setSponByGameResult"
      ]);
      //console.log("clip rows: " + JSON.stringify(this.rows, null, 2));
    },
    readGames() {
      // console.log("GAME ID: " + this.gameID);
      this.$store.dispatch("Admin/readGameByID", [
        "games",
        this.gameID,
        "Admin/setGameByID"
      ]);
    },
    delVideo(id) {
      var confirm = window.confirm(
        "Are you sure you want to delete this record?"
      );
      if (confirm === true) {
        this.$store.dispatch("clip/deleteClip", [
          "clips",
          id,
          "clip/setClipResult"
        ]);
        this.readClipsByGame();
      } else {
        //do nothing
      }
    },
    pressTimer(startTime) {
      this.$store.commit("actionsBtns/setButtonEmpty");
      this.$store.commit("actionsBtns/setButtonPressed", "playMoment");
      this.$store.dispatch("actionsBtns/sendData", [
        startTime,
        "",
        "actionsBtns/setResult"
      ]);
    },
    pressButton(startTime, duration) {
      this.$store.commit("actionsBtns/setButtonEmpty");
      this.$store.commit("actionsBtns/setButtonPressed", "playVideoMoment");
      this.$store.dispatch("actionsBtns/sendData", [
        startTime,
        duration,
        "actionsBtns/setResult"
      ]);
    },
    sendComment() {
      this.$store.commit("clip/setActiveValue", ["comments", this.comment]);
      // console.log("Comment: " + this.comment);
    },
    publishClips() {
      for (var i = 0; i < this.sponByGameResult.length; i++) {
        if (this.sponByGameResult[i].status === "Draft") {
          // console.log("id: " + this.sponByGameResult[i].id);
          this.$store.dispatch("clip/updateClips", [
            "clips",
            this.sponByGameResult[i].id,
            "Published",
            "clip/setClipResult"
          ]);
        }
      }
      Vue.notify({
        group: "publishedClip",
        title: "Important message",
        text: "The clips have been published",
        type: "success"
      });
    },
    selectRow(i) {
      this.expandSelected = true;
      this.rowIndex = i;
      //console.log("index on select: " + this.rowIndex);
    },
    deselect() {
      this.expandSelected = false;
      //console.log("index on deselect: " + this.rowIndex);
    },
    isMobile() {
      if (
        /Android|webOS|iPhone|iPod|BlackBerry|IPad|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        return true;
      } else {
        return false;
      }
    }
  },
  mounted() {
    var v = this;
    v.readGames();
    v.readClipsByGame();
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.onkey);
  }
};
</script>

<style>
.details-div {
  margin-top: 4px;
  margin-bottom: 4px;
}

.details-title {
  font-weight: bold;
}

.button-container {
  padding-top: 5% !important;
  padding-right: 3% !important;
  padding-left: 3% !important;
  padding-bottom: 3% !important;
}

.value-icon {
  padding-top: 15%;
  padding-bottom: 5%;
}

.timer-icon {
  font-size: 20px !important;
}

.comments-title {
  color: #673ab7;
  text-align: left;
  margin-top: 4%;
  margin-left: 3%;
}

.table-title {
  color: #673ab7;
  text-align: left;
}

.comments-input {
  margin-left: 3% !important;
  margin-right: 3% !important;
}

.table.vgt-table {
  font-size: 12px !important;
}

.button-title {
  padding-top: 10%;
  font-size: 12px !important;
  margin-bottom: 0 !important;
  padding-bottom: 0;
}

.button-name {
  position: absolute;
  bottom: 0px;
  text-align: center;
  font-size: 10px !important;
  padding: 5%;

  width: 100%;
}

.timer-container {
  margin-left: 3%;
  margin-right: 3%;
  margin-top: 3%;
  padding: 30px 10px 30px 10px;
}

.timer {
  display: inline;
}

.v-tabs__container {
  height: 40px !important;
}

.v-tabs__div {
  min-width: 113px !important;
}
.v-tabs__slider {
  width: 100% !important;
}

.timer-values {
  padding-left: 5px !important;
  font-size: 16px !important;
}

.radio-btn {
  font-size: 12px !important;
  margin-top: 0px !important;
  padding-top: 0px !important;
}

.radio-btn .v-label {
  font-size: 12px !important;
}

.select-field {
  font-size: 12px !important;
  min-height: 30px !important;
}

.select-field .v-label {
  font-size: 12px !important;
}

.v-text-field.v-text-field--solo .v-input__control {
  min-height: 30px !important;
}

.title-name {
  text-align: center !important;
  font-size: 12px !important;
  padding: 0 !important;
}

.clips-table-container {
  overflow: scroll !important;
  width: 100% !important;
  padding: 0px 0px 12px 0px !important;
  margin-left: 4% !important;
  margin-right: 4% !important;
}

.v-list__tile {
  font-size: 12px !important;
}

.tablerowheight {
  font-size: 12px !important;
  line-height: 1 !important;
}

.value-button-design {
  height: 110px !important;
  width: 100px !important;
}

.vgt-global-search {
  padding: 0px !important;
}

.vgt-table th {
  padding: 5px 5px 5px 5px !important;
}

.vgt-wrap__footer {
  padding: 5px !important;
}

.more-info-tabs {
  margin-left: 3%;
  margin-top: 10%;
  text-align: left;
}
.tabs-sponsor-image {
  margin: auto;
  text-align: center;
  height: 80px !important;
  width: 100px !important;
}

@media only screen and (max-width: 1400px) {
  .value-button-design {
    height: 110px !important;
    width: 100% !important;
    max-width: 90px !important;
  }
  .tabs-sponsor-image {
    height: 70px !important;
    width: 90px !important;
  }
}

@media only screen and (max-width: 1024px) {
  .clips-table-container {
    max-width: 400px !important;
  }
  .value-button-design {
    height: 100px !important;
    width: 100% !important;
    max-width: 80px !important;
  }
  .tabs-sponsor-image {
    height: 60px !important;
    width: 80px !important;
  }
}
</style>